import { render, staticRenderFns } from "./Instant.vue?vue&type=template&id=c8ca55f6&scoped=true&"
import script from "./Instant.vue?vue&type=script&lang=js&"
export * from "./Instant.vue?vue&type=script&lang=js&"
import style0 from "./Instant.vue?vue&type=style&index=0&id=c8ca55f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8ca55f6",
  null
  
)

export default component.exports